<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('search_placeholder') ||
                  '海关编码/商品中文名称/商品英文名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
                <b-button
                  size="sm"
                  class="ml-2"
                  variant="outline-success"
                  @click="
                    $emit('openEditDialog', {
                      type: 'add',
                    })
                  "
                >
                  <b-icon-plus></b-icon-plus>
                  {{ $l('INDEX.btn_add') || '新增' }}
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      top="10vh"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-position="top" size="mini">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_status') || '有效状态'">
              <el-select
                v-model="form.listHscodeStatus"
                :placeholder="$l('form_placeholder_status') || '请选择有效状态'"
                clearable
                filterable
                multiple
                style="width:100%"
              >
                <el-option
                  :label="$l('INDEX.form_label_valid') || '有效'"
                  :value="'Y'"
                />
                <el-option
                  :label="$l('INDEX.form_label_invalid') || '无效'"
                  :value="'N'"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_hscode') || '海关HSCODE'">
              <el-input
                v-model.trim="form.hscode"
                :placeholder="
                  $l('form_placeholder_hscode') || '请输入海关HSCODE'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_hscodeName') || '商品中文名称'">
              <el-input
                v-model.trim="form.hscodeName"
                :placeholder="
                  $l('form_placeholder_hscodeName') || '请输入商品中文名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_hscodeNameEn') || '商品英文名称'">
              <el-input
                v-model.trim="form.hscodeNameEn"
                :placeholder="
                  $l('form_placeholder_hscodeNameEn') || '请输入商品英文名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyStartDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyEndDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listHscodeStatus: ['Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
